const config = {
  version: '2.1.0',
  type: 'js'
};

export default config;


/** WEBPACK FOOTER **
 ** ./src/config.ts
 **/